/**
 * @description: v4 Feature flags enum, may auto-generate in future
 * Taken from: https://git.perkbox.io/perkbox-services/auth/feature-flags/-/blob/master/public/feature_flags.go
 */
enum FeatureFlags {
  GlobalAdminFlag = "xs:global_admin", // meta flag that applies all role flags
  GodModeFlag = "GodModeFlag", // meta flag that applies all internal admin flags, allows creating/updating internal admins

  // Core
  CoreGroupsFullAccess = "CoreGroupsFullAccess", // crud all business groups
  CoreTeamsFullAccess = "CoreTeamsFullAccess", // crud all teams
  CoreTeamsSelfBusinessFullAccess = "CoreTeamsSelfBusinessFullAccess", // crud all teams in my business
  CoreBusinessFullAccess = "CoreBusinessFullAccess", // crud all businesses
  CoreBusinessSelfBusinessModify = "CoreBusinessSelfBusinessModify", // modify my own business
  CoreRolesFullAccess = "CoreRolesFullAccess", // crud all roles
  CoreUsersFullAccess = "CoreUsersFullAccess", // crud all users
  CoreUsersSelfBusinessFullAccess = "CoreUsersSelfBusinessFullAccess", // crud all users in my business
  CoreUsersSelfBusinessModifyOnly = "CoreUsersSelfBusinessModifyOnly", // modify users in my business
  GlobalBeta = "GlobalBeta",

  // Auth
  AuthIAdminReadOnly = "AuthIAdminReadOnly", // view internal admins
  AuthGhost = "AuthGhost", // ghost a business
  AuthMFAManage = "AuthMFAManage", // view and delete a user's mfa setup
  AuthManageSessionsAndDevices = "AuthManageSessionsAndDevices",
  AuthIAdminCanGDPRUsers = "AuthIAdminCanGDPRUsers",

  // Onboarding
  OnboardingUserFullAccess = "OnboardingUserFullAccess", // crud all user onboarding
  OnboardingBusinessFullAccess = "OnboardingBusinessFullAccess", // crud all business onboarding
  OnboardingBusinessSelfBusinessFullAccess = "OnboardingBusinessSelfBusinessFullAccess", // crud business onboarding for my business

  // OpenAPI
  OpenApiFullAccess = "OpenApiFullAccess",

  // ChannelPartner
  ChannelPartnerFullAccess = "ChannelPartnerFullAccess",

  // Perks
  PerksFullAccess = "PerksFullAccess",
  PerksEnabledForTeam = "xs:perks:team_enabled",
  PerksCardlinkedEnabledForTeam = "xs:perks:team_cardlinked",
  PerksGeoEnabledForTeam = "xs:perks:team_geo",
  PaymentsZipDisabled = "PaymentsZipDisabled",

  // Insights
  InsightsFullAccess = "InsightsFullAccess",
  InsightsEnabledForTeam = "xs:ins:team_enabled",

  // Medical
  MedicalFullAccess = "MedicalFullAccess",
  MedicalEnabledForTeam = "xs:med:team_enabled",

  // R&R
  RnRFullAccess = "RnRFullAccess",
  RnREnabledForTeam = "xs:rnr:team_enabled",
  FlexiRewardsFullAccess = "FlexiRewardsFullAccess",
  FlexiRewardsHidden = "FlexiRewardsHidden",
  RecognitionHidden = "RecognitionHidden",

  // Reporting
  ReportingFullAccess = "ReportingFullAccess",
  ReportingSelfBusinessFullAccess = "ReportingSelfBusinessFullAccess",
  ReportingBeta = "ReportingBetaAccess",

  // Wallet
  TenantWalletFullAccess = "TenantWalletFullAccess",
  TenantWalletEnabledForTeam = "xs:twallet:team_enabled",
  UserWalletEnabledForTeam = "xs:uwallet:team_enabled",

  // CultureHub (Homepage)
  CultureHubEnabledForTeam = "xs:culturehub:team_enabled",

  // ProductSettings
  ProductSettingsFullAccess = "ProductSettingsFullAccess",
  ProductSettingsSelfBusinessFullAccess = "ProductSettingsSelfBusinessFullAccess",

  // Wellness
  WellnessHub = "WellnessHub",
  WellnessHidden = "WellnessHidden",

  // Content cards
  ContentCards = "ContentCards"
}

export default FeatureFlags
